import React from "react";
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

interface Props {
  data: CompetitionData;
  clubToHighlight?: Number;
}

const ChartLineCompetitionRanking: React.FC<Props> = ({ data, clubToHighlight }) => {
  const rootStyles = getComputedStyle(document.documentElement);
  const primaryColorRgb = rootStyles.getPropertyValue("--primary-color-rgb").trim();

  const clubNames = data.participants?.reduce((acc, p) => {
    acc[p.id] = p.name;
    return acc;
  }, {});

  const labels = data.rankingHistory.map((r) => r.date);
  const datasets = data.participants.map((club) => {
    const isHighlighted = clubToHighlight === club.id;
    const pointsData = data.rankingHistory.map((day) => {
      const ranking = day.rankings.find((r) => r.clubId === club.id);
      return ranking ? ranking.points : null;
    });

    return {
      label: club.name,
      data: pointsData,
      borderWidth: 2,
      fill: false,
      tension: 0.3,
      borderColor: isHighlighted ? `rgba(${primaryColorRgb},1)` : `rgba(${primaryColorRgb},.2)`,
      pointRadius: isHighlighted ? 3 : 2,
      pointBackgroundColor: isHighlighted ? `rgba(${primaryColorRgb},1)` : `rgba(${primaryColorRgb},.5)`,
    };
  });

  const getData = () => ({ labels, datasets });

  return (
    <div className="position-absolute h-100 w-100">
      <Line
        data={getData()}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
              position: "top",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                boxWidth: 6,
                boxHeight: 6,
                padding: 10,
              },
            },
            datalabels: { display: false },
          },
          scales: {
            x: {
              ticks: { beginAtZero: true },
              grid: { display: false },
            },
            y: {
              ticks: { display: true },
              grid: { display: false },
            },
          },
          layout: {
            padding: { top: 30 },
          },
        }}
      />
    </div>
  );
};

export default ChartLineCompetitionRanking;
